<div>
  <p>
    You are about to create an Initial Authorization request using the Portal.
  </p>
  <br/>
  <p class="font-semibold error">
    Please note that urgent requests cannot be requested via the Carelon Medical Benefits Management Portal.
    If you have an urgent request and all required documentation,
    please call the Carelon Intake department at (844) 411-9622, option 2.
  </p>
  <br/>
  <p>
    To create an Initial Authorization request, you must have all the
    information below:
  </p>
  <ul class="list-disc ps-8">
    <li>ICD-10 code (at least one)</li>
    <li>Ordering Physician phone, fax, address, and NPI</li>
    <li>Supporting clinical documentation</li>
    <li>Anticipated servicing Post-Acute Care facility</li>
  </ul>
  <p>
    If you do not have all of the above
    information, please obtain the required information, then return to the Portal to
    create an Initial Authorization request.
  </p>
  <br/>
  <p>
    Please call the Carelon intake department at (844) 411-9622 for further
    assistance.
  </p>
  <div class="flex justify-between mt-6">
    <button
      pButton
      severity="danger"
      aria-label="Cancel Create Authorization"
      label="Cancel"
      icon="pi pi-times"
      type="button"
      (click)="onCancel()"
    ></button>
    <button
      pButton
      aria-label="Continue Create Authorization"
      label="Continue"
      icon="pi pi-chevron-right"
      iconPos="right"
      class="ml-2"
      type="button"
      [loading]="loading"
      (click)="onContinue()"
    ></button>
  </div>
</div>
